<template>
    <div>
        <v-card v-if="items.length" class="pa-0" style="border-left: 4px solid #fb8c00;">
            <v-card-title class="font-weight-bold py-2">
                <v-icon left color="orange darken-1" class="mr-1">mdi-school-outline</v-icon>
                <span style="font-size: 15px;">Pending Training</span>
                <v-chip x-small color="orange darken-1" text-color="white" class="ml-2">{{ items.length }}</v-chip>
                <v-spacer></v-spacer>
                <v-btn x-small text color="primary" to="/my-trainings">view all</v-btn>
            </v-card-title>
            <v-divider class="my-0"></v-divider>

            <v-list dense class="py-0">
                <v-list-item v-for="item in items" :key="item.id" style="border-bottom: 1px solid #eee;">
                    <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                            {{ item.training.title }}
                            <a v-if="item.training.training_link" :href="item.training.training_link" target="_blank" rel="noopener" class="ml-1" title="Open training">
                                <v-icon x-small color="primary">mdi-open-in-new</v-icon>
                            </a>
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="item.training.provider">{{ item.training.provider }}</v-list-item-subtitle>
                        <v-list-item-subtitle>
                            <span v-if="item.training.due_date" :class="{ 'red--text font-weight-medium': item.is_overdue }">
                                Due {{ $localeDate(item.training.due_date) }}
                            </span>
                            <span v-else>No due date</span>
                            <v-chip v-if="item.is_overdue" x-small label color="red" text-color="white" class="ml-1 px-1 text-uppercase">overdue</v-chip>
                            <v-chip v-if="item.status == 'rejected'" x-small label color="red" outlined class="ml-1 px-1 text-uppercase">rejected</v-chip>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="item.status == 'rejected' && item.review_remarks" class="red--text">
                            {{ item.review_remarks }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn x-small color="blue" class="white--text" @click="$refs.submitModal.open(item)">
                            {{ item.status == 'rejected' ? 're-upload' : 'upload certificate' }}
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-card>

        <submit-certificate-modal ref="submitModal" @saved="getItems"></submit-certificate-modal>
    </div>
</template>

<script>
import SubmitCertificateModal from '../staff-training/SubmitCertificateModal.vue'

// Renders nothing unless the staff has trainings still owing a certificate.
// Emits `loaded` with the count so the dashboard can collapse its column.
export default {
    components: { SubmitCertificateModal },
    data: () => ({
        items: [],
    }),
    methods: {
        getItems() {
            this.$axios.get('/api/staff-training/my/pending', { silentError: true }).then((resp) => {
                this.items = resp.data
            }).catch(() => {
                this.items = []
            }).finally(() => {
                this.$emit('loaded', this.items.length)
            })
        },
    },
    mounted() {
        this.getItems()
    },
}
</script>
